import React from 'react';
import ViewGridIcon from '@heroicons/react/outline/ViewGridIcon.js';
import ViewGridSolidIcon from '@heroicons/react/solid/ViewGridIcon.js';
import { Link, useLocation } from 'react-router-dom';
import { SystemSpaceSlug, useSpaceUtil } from '@tribeplatform/react-sdk/hooks';
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar';
export const CollectionMenuSimple = ({ collections, }) => {
    const { generatePath, matchPath } = useSpaceUtil();
    const location = useLocation();
    return (React.createElement(NavVertical, { className: "block-collection-menu" },
        React.createElement("div", { className: "space-y-2" }, collections.map(collection => {
            var _a;
            const hasSpaces = (_a = collection === null || collection === void 0 ? void 0 : collection.spaces) === null || _a === void 0 ? void 0 : _a.totalCount;
            const isActive = matchPath(SystemSpaceSlug.COLLECTION, location.pathname, { id: collection.id });
            if (!hasSpaces) {
                return null;
            }
            return (React.createElement(NavVertical.Group, { key: collection.id },
                React.createElement(NavVertical.Item, { active: !!isActive, as: Link, to: generatePath(SystemSpaceSlug.COLLECTION, {
                        id: collection.id,
                    }), leadingIcon: isActive ? React.createElement(ViewGridSolidIcon, null) : React.createElement(ViewGridIcon, null) },
                    React.createElement("span", { className: "truncate flex-grow font-semibold text-sm text-content-on-background-subdued" }, collection.name))));
        }))));
};
//# sourceMappingURL=CollectionMenuSimple.js.map